import React, { useEffect, useState } from "react";
import classes from "./signup.module.css";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { Link } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ClipLoader from "react-spinners/PulseLoader";
import useRandomCity from "./useRandomcity";

function SignupPage() {
	// error and loading state
	const [error, setError] = useState(false);
	const [loading, setLoading] = useState(false);

	// form email and password state
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");

	//importing and using custom hook
	//Random city
	const [city_loading, city_error, city, refreshCity] = useRandomCity();

	// check if image has loaded 
	const [imageLoaded, setImageLoaded] = useState(false);
	const [image, setImage] = useState("");


	// Refresh city every 20 seconds
	useEffect(() => {
		const interval = setInterval(refreshCity, 70000);
		return () => clearInterval(interval);
	}, [refreshCity]);

	//Pre load image
	useEffect(() => {
		if (city_loading || !city?.image) {
			return;
		}
		
		const image = new Image();
		image.src = city?.image;
		image.onload = () => {
			setImageLoaded(true);
			setImage(city?.image);
		};
	}, [city?.image, city_loading]);


	// load css classes
	const fade_in_classes = [classes.signUpImg];
	if (image && imageLoaded) {
		fade_in_classes.push(classes.loaded);
	}


	const handleSignup = async (e) => {
		e.preventDefault();
		try {
			const auth = getAuth();
			setLoading(true);
			setError(false);
			await createUserWithEmailAndPassword(auth, email, password);
		} catch (error) {
			console.log("Auth error", error);
			setError(true);
			alert(error);
		} finally {
			setLoading(false);
		}
	};


	return (
		<div className={classes.signup}>
			<Row>
				<Col sm={6} md={6} lg={7} xl={8} xxl={8}>
					{!city_loading && city_error && (
						<div className={classes.errorImg}>
								<img
									src="./images/chiang-mi.jpg"
									alt="chiang mi"
								/>
						</div>
					)}

					{city_loading && (
						<div className={classes.loadingAnimation}>
							<ClipLoader
								color={"#007FFF"}
								loading={city_loading}
								size={10}
								aria-label="Loading Spinner"
								data-testid="loader"
							/>
						</div>
					)}

					{!city_loading && !city_error && (
						<div className={fade_in_classes.join(" ")}>
							{imageLoaded && (
								<img src={image} alt={city?.address} />
							)}
						</div>
					)}
				</Col>

				<Col sm={6} md={6} lg={5} xl={4} xxl={4}>
					<div className={classes.signupCard}>
						<h2 className={classes.headerTwo}>Signup</h2>

						<form onSubmit={handleSignup} className={classes.form}>
							{error &&
								alert(
									"Sorry there was an error, please try again..."
								)}
							<div className={classes.signupform}>
								<label
									htmlFor="Email"
									className={classes.label}
								>
									Username
								</label>
								<input
									className={classes.signupInput}
									type="email"
									id="Email"
									value={email}
									placeholder="Email"
									onChange={(e) => setEmail(e.target.value)}
									required
								/>
							</div>
							<div className={classes.signupform}>
								<label
									htmlFor="password"
									className={classes.label}
								>
									Password
								</label>
								<input
									className={classes.signupInput}
									type="password"
									value={password}
									placeholder="Password"
									onChange={(e) =>
										setPassword(e.target.value)
									}
									id="password"
									required
								/>
							</div>
							<div>
								<button
									type="submit"
									disabled={loading}
									className={classes.signupButton}
								>
									{loading ? (
										<>
											{"Loading... "}
											<Spinner
												as="span"
												animation="border"
												size="sm"
												role="status"
												aria-hidden="true"
											/>
										</>
									) : (
										"Signup"
									)}
								</button>
								<p style={{ textAlign: "center" }}>
									Already got an account? <br />
								</p>
								<div style={{ textAlign: "center" }}>
									<Link
										style={{
											marginLeft: "auto",
											marginRight: "auto",
										}}
										to="/login"
									>
										Login
									</Link>
								</div>
							</div>
						</form>
					</div>
				</Col>
			</Row>
		</div>
	);
}

export default SignupPage;
